import type { InvoiceBillingStatus } from '@weft/types';
import { INVOICE_BILLING_STATUSES } from '@weft/types';
import cn from 'classnames';
import type { HTMLAttributes } from 'react';
import React from 'react';

type StatusInfoCardProps = HTMLAttributes<HTMLDivElement> & {
  title: string;
  status?: InvoiceBillingStatus;
  as?: React.ElementType;
};

export const StatusInfoCard = React.forwardRef<HTMLDivElement, StatusInfoCardProps>(
  ({ title, children, as, className: externalClassName, status = INVOICE_BILLING_STATUSES.Paid, ...props }, ref) => {
    const className = cn(
      'rounded-2lg relative flex flex-1 flex-col justify-between overflow-hidden border border-[#dfebf1] bg-white px-5 py-4',
      'before:absolute before:left-0 before:top-0 before:h-full before:w-[3px] before:bg-gradient-to-b before:content-[""]',
      { 'before:from-[#00D1FF] before:to-[#00FFA3]': status === INVOICE_BILLING_STATUSES.None },
      { 'before:from-[#FFF500] before:to-[#FF008A]': status === INVOICE_BILLING_STATUSES.Overdue },
      { 'before:from-[#FCE93B] before:to-[#FFC328]': status === INVOICE_BILLING_STATUSES.PendingPayment },
      { 'before:from-[#C250FF] before:to-[#C250FF]': status === INVOICE_BILLING_STATUSES.Paid },
      externalClassName,
    );

    return React.createElement(
      as ?? 'div',
      {
        className,
        ref,
        ...props,
      },
      <>
        <div className='flex items-center justify-between'>
          <p className='text-sm font-normal text-[#73829E]'>{title}</p>
        </div>

        <div className='flex flex-1 items-end'>
          {children}
        </div>
      </>,
    );
  },
);
